
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { FormInput } from './PaymentFormSection';
import { PaymentFormValues } from './types';

type BankAccountFormProps = {
  form: UseFormReturn<PaymentFormValues>;
}

const BankAccountForm: React.FC<BankAccountFormProps> = ({ form }) => {
  return (
    <div className="space-y-4">
      <FormInput
        form={form}
        name="accountHolderName"
        label="Account Holder Name"
        placeholder="John Doe"
      />
      
      <FormInput
        form={form}
        name="bankName"
        label="Bank Name"
        placeholder="Bank of America"
      />
      
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <FormInput
          form={form}
          name="routingNumber"
          label="Routing Number"
          placeholder="123456789"
          description="9-digit routing number"
        />
        
        <FormInput
          form={form}
          name="accountNumber"
          label="Account Number"
          placeholder="•••••••••••"
          type="password"
        />
      </div>
    </div>
  );
};

export default BankAccountForm;
